export const requestUrl = process.env.VUE_APP_API_URL || (
  process.env.NODE_ENV === 'production'
    ? 'https://www.jdbsk.com/'
    : process.env.NODE_ENV === 'dev'
    ? 'https://dev2.zjsxrz.com'
    : 'http://localhost:9092');

// Relative legacy business files are still retained in the former bucket.
// New public system resources must use files.jdbsk.com directly instead.
export const ossUrl = 'https://zjsxrz.oss-cn-hangzhou.aliyuncs.com';
